import React, {useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../modal";
import { ToastContainer, toast } from "react-toastify";

const Supervisor = ({createSupervisor, supervisorRes}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0)
    const [inputList, setInputList] = useState(
        [{first_name: '', last_name: '', project_id: '', phone_no: ''}]
    );
    const [firstNameValidation, setFirstNameValidation] = useState("")
    const [lastNameValidation, setLastNameValidation] = useState("")
    const [projectIdValidation, setProjectIdValidation] = useState("")
    const [phoneNoValidation, setPhoneNoValidation] = useState("")

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]

        setFirstNameValidation("")
        setLastNameValidation("")
        setProjectIdValidation("")
        setPhoneNoValidation("")

        if(inputValues.first_name === ""){
            setFirstNameValidation("First name is required")
        }
        // else if(inputValues.last_name === ""){
        //     setLastNameValidation("Last name is required")
        // }
        else if(inputValues.project_id === ""){
            setProjectIdValidation("Project id is required")
        }else if(inputValues.phone_no === "" || inputValues.phone_no.length > 10 || inputValues.phone_no.length < 10){
            setPhoneNoValidation("Phone Number is required and must be 10 digit")
        }

        if(inputValues.last_name !== ""){
            var text = inputValues.last_name;
            if(text.includes("valet") || text.includes("Valet") || text.includes("supervisor") || text.includes("Supervisor")) {
               toast.error('Please remove valet or supervisor keyword from last name.');
               return false;
            }
        }

        if (inputValues.first_name !== '' && inputValues.project_id !== '' && inputValues.phone_no !== '' && inputValues.phone_no.length === 10) {
            setIsLoading(true)
            await createSupervisor(inputValues)
            setIsLoading(false)
            setCount(count+1)
        }
    }

    return (
        <>
            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        {supervisorRes !== null && supervisorRes.response.status !== 200 &&
                            <CustomModal msg={supervisorRes.response.message} click={count}/>}
                        {supervisorRes !== null && supervisorRes.response.status === 200 &&
                            <CustomModal msg={supervisorRes.response.message} isPageLoad={true} click={count} />}
                        <div className="card-header">
                            {localization.supervisor}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="validation">{firstNameValidation}</div>
                                    <ConstantInput
                                        label={localization.firstName}
                                        type="text"
                                        value={inputList.first_name}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'first_name', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="validation">{lastNameValidation}</div>
                                    <ConstantInput
                                        label={localization.lastName}
                                        type="text"
                                        value={inputList.last_name}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'last_name', 0);
                                        }}
                                        // required
                                        // isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="validation">{phoneNoValidation}</div>
                                    <ConstantInput
                                        label={localization.phoneNumber}
                                        type="number"
                                        value={inputList.phone_no}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'phone_no', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="validation">{projectIdValidation}</div>
                                    <ConstantInput
                                        label={localization.projectId}
                                        type="number"
                                        value={inputList.project_id}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'project_id', 0);
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default Supervisor
